import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';

import { NotificationItem } from '../../core/notifications/notification.models';
import { NotificationService } from '../../core/notifications/notification.service';

@Component({
  selector: 'app-notification-host',
  standalone: true,
  imports: [CommonModule],
  template: `
    <section *ngIf="notifications().length > 0" aria-label="Notifiche applicazione">
      <div *ngFor="let item of notifications()" [attr.data-kind]="item.kind" style="border:1px solid #ccc; padding:8px; margin:8px 0;">
        <strong *ngIf="item.title">{{ item.title }}</strong>
        <p style="margin:4px 0;">{{ item.message }}</p>
        <div *ngIf="item.actions.length > 0">
          <button
            type="button"
            *ngFor="let action of item.actions"
            (click)="runAction(item, action.id)"
            style="margin-right:6px;"
          >
            {{ action.label }}
          </button>
        </div>
        <button type="button" (click)="dismiss(item.id)">Chiudi</button>
      </div>
    </section>
  `,
})
export class NotificationHostComponent {
  private readonly notificationService = inject(NotificationService);
  readonly notifications = this.notificationService.notifications;

  dismiss(notificationId: string): void {
    this.notificationService.dismiss(notificationId);
  }

  runAction(item: NotificationItem, actionId: string): void {
    this.notificationService.runAction(item.id, actionId);
  }
}
